import {
  ErrorResponseCodeType,
  EndPointsNames,
  ApiCredentialsType,
} from '_core/types';
import { setEntityName } from '_core/util/object';

export const API_DOMAIN: EndPointsNames = 'ApiAccount';
export const ENDPOINT_API_PATH = 'v1/members/password';
export const ENTITY_NAME = setEntityName(ENDPOINT_API_PATH);
const API_CREDENTIALS_TYPE: ApiCredentialsType = 'TOKEN_CREDENTIALS';
const URL_POSTMAN =
  'https://smiles-sa.postman.co/workspace/1aa3f7db-730f-4a9e-8904-3201cc3d9669/api/af54471e-29ce-4f69-b0a7-805ae0a4e868?version=5c9b50e6-4921-4d6c-9587-3dd7a8b0adba&tab=overview';

export const CODE_ERRORS: ErrorResponseCodeType[] = [
  {
    code: '1',
    bussinessErrorVariant: 'errorService',
    message: 'Ocorreu um erro inesperado (favor contatar a Smiles)',
  },
  {
    code: '45',
    bussinessErrorVariant: 'wrongParams',
    message: 'Parâmetros de entrada insuficientes',
  },
  {
    code: '46',
    bussinessErrorVariant: 'userNotFound',
    message: 'Não foi possível localizar o membro',
  },
  {
    code: '57',
    bussinessErrorVariant: 'errorService',
    message: 'Não foi possível analisar a solicitação de Reset de Senha',
  },
  {
    code: '54',
    bussinessErrorVariant: 'errorService',
    message: 'Não foi possível criar a solicitação de Reset de Senha',
  },
];

export default {
  API_DOMAIN,
  ENDPOINT_API_PATH,
  API_CREDENTIALS_TYPE,
  URL_POSTMAN,
  CODE_ERRORS,
  ENTITY_NAME,
};
